<template>
  <div class="big">
    <div class="page_title">药房信息列表</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div class="box">
            <div class="searchbox">
              <div>
                <span>药房名称</span>
                <!-- <el-input
                  v-model="hospital_name"
                  style="width: 140px; margin: 0 10px 0 5px"
                  @input="search"
                  clearable
                ></el-input> -->
                <myInputSerch v-model="hospital_name" @update="search" style="margin:0 10px 0 10px;"></myInputSerch>

                <span>药房类型</span>
                <el-select
                  v-model="org_type"
                  placeholder="请选择"
                  style="width: 140px; margin: 0 10px 0 5px"
                  @change="search"
                >
                  <el-option
                    label="全部"
                    :value="0"
                  ></el-option>
                  <el-option
                    v-for="item in org_type_list"
                    :key="item.org_type"
                    :label="item.org_type_name"
                    :value="item.org_type"
                  ></el-option>
                </el-select>
                <span>提交时间</span>
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 225px; margin: 0 5px 0 10px"
                  @change="search"
                ></el-date-picker>
                <el-button
                  type="info"
                  style="background-color: #eceff2; color: #747981"
                  @click="search"
                  size="medium"
                >查询</el-button>
                <span style="margin: 0 8px 0 10px">是否开放</span>
                <el-radio-group
                  v-model="hospiatl_type"
                  @change="search"
                >
                  <el-radio :label="0">全部</el-radio>
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column
                  label="药房名称"
                  prop="hospital_name"
                ></el-table-column>
                <el-table-column
                  label="药房类型"
                  prop="org_type"
                ></el-table-column>
                <el-table-column
                  label="纳税人识别号"
                  prop="identification_number"
                ></el-table-column>
                <el-table-column label="是否开放">
                  <template slot-scope="scope">
                    <span v-if="scope.row.hospiatl_type == 1">开放</span>
                    <span v-if="scope.row.hospiatl_type == 2">不开放</span>
                    <span v-if="scope.row.hospiatl_type == 3">部分开放</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="云诊所名称"
                  prop="hospital_clinic"
                ></el-table-column>
                <el-table-column
                  label="所在地区"
                  prop="address"
                ></el-table-column>
                <el-table-column
                  label="提交日期"
                  prop="create_time"
                ></el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status">正常</span>
                    <span
                      style="color: #f24b2f"
                      v-else
                    >锁定</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="toDetail(scope.row.hospital_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('100')
                          : false
                      "
                    >查看详情</el-button>
                    <el-button
                      type="text"
                      v-if="scope.row.status"
                      @click="changeHospitalStatus(scope.row.hospital_id, 1)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('99')
                          : false
                      "
                    >锁定</el-button>
                    <el-button
                      type="text"
                      v-if="!scope.row.status"
                      @click="changeHospitalStatus(scope.row.hospital_id, 2)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('99')
                          : false
                      "
                    >解锁</el-button>

                    <el-dropdown
                      style="margin-left: 8px"
                      trigger="click"
                      @command="
                        (value) => {
                          return updateStatus(value, scope.row.hospital_id);
                        }
                      "
                    >
                      <span class="el-dropdown-link">
                        <el-button type="text">设置开放</el-button>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="1">开放</el-dropdown-item>
                        <el-dropdown-item :command="2">不开放</el-dropdown-item>
                        <el-dropdown-item :command="3">部分云诊所开放</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <span
                      style="margin-left: 10px; color: #669961"
                      v-if="admin_id == 1"
                    >
                      测试
                      <el-switch
                        v-model="scope.row.is_test"
                        active-color="#669961"
                        @change="
                          (value) => {
                            return setTest(value, scope.row.hospital_id);
                          }
                        "
                      ></el-switch>
                    </span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                style="margin:20px 0"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hospital from '../../../api/hospital';
import myInputSerch from '@/components/myInputSerch';
import platform from '../../../api/platform';
import dayjs from 'dayjs';
export default {
  components: {
    myInputSerch
  },
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      org_type_list: [],
      hospital_name: '',
      org_type: 0,
      hospiatl_type: 0,
      date: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    }
  },
  methods: {
    //获取配置信息
    getConfig() {
      platform.getConfigList().then((res) => {
        if (res.code == 0) {
          this.org_type_list = res.data.org_type_list;
        }
      });
    },
    //设置测试账号
    setTest(value, hospital_id) {
      let text = '';
      let status = '';
      if (value) {
        text = '确定将该账号设置为测试账号？';
        status = 1;
      } else {
        text = '确定取消测试账号？';
        status = 2;
      }

      this.$confirm(text, '提示消息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          hospital.setTestHospital({ hospital_id, status }).then((res) => {
            if (res.code == 0) {
              this.$message.success('设置成功');
              this.getList();
            }
          });
        })
        .catch(() => {
          this.getList();
        });
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        hospital_name: this.hospital_name,
        org_type: this.org_type,
        hospiatl_type: this.hospiatl_type
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.end_time = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      hospital.getHospitaList(data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = platform.timestampToDate(item.create_time);
            item.is_test = item.is_test == 1 ? true : false;
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //药房详情
    toDetail(hospital_id) {
      this.$router.push({ path: 'hospitallistdetail', query: { hospital_id } });
    },
    //锁定/解锁
    changeHospitalStatus(hospital_id, hospital_status) {
      let text = '';
      if (hospital_status == 1) {
        text = '锁定后药房不可运营，确定操作？';
      } else if (hospital_status == 2) {
        text = '确定更改药房状态？';
      }
      this.$confirm(text, '提示', {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          hospital
            .changeHospitalStatus({ hospital_id, hospital_status })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('药房状态已经更改!');
              }
              this.getList();
            });
        })
        .catch();
    },
    //是否开放
    updateStatus(type, hospital_id) {
      let text = '';
      if (type == 1) {
        text = '是否将药房设置为开放？平台医生均可选择';
      } else if (type == 2) {
        text = '是否将药房设置为不开放？平台医生不可选择';
      } else if (type == 3) {
        text = '是否将药房设置为部分云诊所开放？';
      }
      this.$confirm(text, '提示', {
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then((res) => {
          let data = {
            hospital_id: hospital_id,
            hospital_type: type
          };
          return this.axios.post('platform/hospital/changeHospitalType', data);
        })
        .then(() => {
          this.$message.success('设置成功');
          this.getList();
        });
    }
  },
  created() {
    this.getConfig();
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.uploadimg {
  width: 242px;
  height: 182px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;

  .avatar {
    width: 240px;
    height: 180px;
  }
  .uploader-icon {
    padding-top: 30px;
    line-height: 30px;
    color: #669961;
  }
}
</style>
<style lang="scss">
.mydialog .mydia .el-dialog__header {
  border-radius: 5px 5px 0 0;
  border-bottom: solid 1px #dcdcde;
  text-align: left;
  font-weight: 600;
}

.mydialog .mydia .el-dialog {
  border-radius: 5px;
}

.mydialog .mydia .el-dialog__body {
  padding: 0px 0px 30px;
  color: #262626;
}
</style>